// extracted by mini-css-extract-plugin
export default {"JobworkPartyFormModal":"JobworkPartyFormModal_JobworkPartyFormModal__ZWOfG"};